Librarian.Modules.Tasks = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-tasks-",
        title: "Tasks",
        resultOptions: null
    },

    resultOptions: null,
    className: "modules-task",

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
        if (!options.resultOptions)
            options.resultOptions = {};

        this.resultOptions = Object.merge(this.getDefaultResultOptions(), options.resultOptions);
    },

    getDefaultResultOptions: function() {
        return {
            startRow: 1,
            maxRows: 2400,
            viewName: null,
            fields: {},
            orderByColumns: [{ name: "DueDate", order: "ASC" }],
            crmId: -1,
            crmType: Librarian.crmType.opportunity,
            taskType: Librarian.crmTaskType.task,
            parentId: -1,
            statuses: [],
            startDate: null,
            endDate: null,
            state: Librarian.crmOpportunityState.active
        };
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();
        this.loadData();
    },

    loadData: function() {
        this.containerEl.empty();
        // Create the container element and generate the URL
        var parentContEl = new Element("div").injectInside(this.containerEl),
            url = Librarian.path.getCrmUrl("getcrtsfm") + "&out=cjson&in=cjson",
            options = this.resultOptions;

        if (options.taskType == Librarian.crmTaskType.event) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            options.startDate = today;
        }

        options = JSON.stringify(options);
        if (typeof Base64 != "undefined")
            options = Base64.encode(options);

        this.request = new Librarian.Request.JSON({
            url: url,
            data: options,
            method: "post",
            onSuccess: function(tasks) {
                parentContEl.empty();

                if (!tasks || (tasks.length == 0))
                    this.showNoTask(parentContEl);
                else {
                    for (var i = 0, len = tasks.length; i < len; i++)
                        this.buildTaskItem(tasks[i], parentContEl);
                }
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    },

    showNoTask: function(parentContEl) {
        var className = this.className + "-no-item";
        parentContEl.addClass(className + "-wrapper");

        new Element("span", {
            "class": className + "-text",
            "text": Librarian.Lang.getString("modules_" + (this.resultOptions.taskType == Librarian.crmTaskType.event ? "events" : "tasks") + "_none")
        }).injectInside(parentContEl);
    },

    buildTaskItem: function(task, parentContEl) {
        if (!task || !parentContEl)
            return;

        var className = this.className + "-item",
            itemContEl = new Element("div", {
                "class": className,
                "id": className + '-' + task.taskId
            }).injectInside(parentContEl);

        // Task Date
        var dueDate = Librarian.Utils.extractDateFromString(task.dueDate),
            day = dueDate ? dueDate.getDate() : "---",
            month = dueDate ? dueDate.format("%b") : "OPEN",
            complete = task.status == Librarian.crmTaskStatus.complete,
            overDue = !complete && (dueDate ? dueDate < (new Date()) : false),
            dateContEl = new Element("div", {
                "class": className + "-date-cont",
                "styles": {
                    "border-color": this.getUrgencyColor(task.urgency, task.stageType)
                }
            }).injectInside(itemContEl);
        new Element("span", {
            "class": className + "-day",
            "text": day
        }).injectInside(dateContEl);
        new Element("span", {
            "class": className + "-month",
            "text": month
        }).injectInside(dateContEl);
        if (overDue) {
            new Element("span", {
                "class": className + "-urgent",
                "title": "Overdue"
            }).injectInside(dateContEl);
        }

        // Task Details
        var name = (task.name || '').trim(),
            oppName = (task.opportunityName || '').trim(),
            infoContEl = new Element("div", {
                "class": className + "-info-cont pointer"
            }).injectInside(itemContEl);
        new Element("span", {
            "class": className + "-name ellipsis",
            "title": name,
            "text": name
        }).injectInside(infoContEl);
        new Element("span", {
            "class": className + "-opp ellipsis",
            "title": oppName,
            "text": oppName
        }).injectInside(infoContEl);

        infoContEl.addOnClick(function() { this.openProjectRoom(task.crmId); }, this);
    },

    getScore: function (stageType, score) {
        return ((stageType == Librarian.crmStageType.closedWon) || (stageType == Librarian.crmStageType.closedLost)) ? "---" : parseInt(score, 10);
    },

    getUrgencyColor: function (urgency, stageType) {
        if (stageType == Librarian.crmStageType.closedWon)
            return "#82BD3D";
        if (stageType == Librarian.crmStageType.closedLost)
            return "#333";
        if (urgency >= 80)
            return "#D2254B";
        if (urgency >= 60)
            return "#F5821E";
        if (urgency >= 40)
            return "#F4CD42";
        return "#0078BE";
    },

    openProjectRoom: function(oppId) {
        var url = Librarian.path.getAppPath("dashboard") + "/project.htm?libName=" + Librarian.path.getUrlLibraryName();
        if (url.indexOf('?') == -1)
            url += '?';
        else
            url += '&';
        window.open(url + "oppId=" + oppId, "Project" + oppId, "width=990,height=770");
    }
});